export class User {
  constructor(
    readonly id: string,
    readonly workstationId: string | null,
  ) {}
}
